import { useEffect, useRef, useState } from 'react'
import { RefreshCcw } from 'lucide-react'
import type { Story } from '../data'
import { isAiGeneratedOriginal } from '../lib/audio-disclosure'
import { storyRenderMode } from '../lib/render-mode'
import { sampleSourceLink } from '../lib/story-samples'
import { Notice, SecondaryButton } from './ui'

/** This player is always the original. Generated audio only comes from a generation job. */
export function StoryAudioPreview({ story }: { story: Story }) {
  const audio = useRef<HTMLAudioElement>(null)
  const [failed, setFailed] = useState(false)
  const source = story.sampleUrl
  const sourcePage = story.sourcePage ? sampleSourceLink(story.sourcePage) : null
  useEffect(() => { const player = audio.current; return () => { player?.pause() } }, [source])
  if (!source) return null
  return <section className="generated-audio story-original" aria-labelledby="original-story-heading">
    <span className="eyebrow">ORIGINAL NARRATION</span>
    <h2 id="original-story-heading">원본 동화 미리듣기</h2>
    <p>{storyRenderMode(story) === 'renarration' ? '이 음원은 원본 미리듣기예요. 부모 목소리 결과는 동화 대본을 새로 읽어 만들어요.' : '등록한 부모 목소리로 바꾸기 전의 원본 낭독이에요.'}</p>
    {isAiGeneratedOriginal(story) && <p className="sample-source">이 원본 낭독은 AI가 생성한 음원이에요.</p>}
    <audio ref={audio} controls preload="metadata" src={source} aria-label={`${story.title} 원본 낭독`} onError={() => setFailed(true)} />
    {story.sourceLabel && <p className="sample-source">{story.sourceLabel}</p>}
    {sourcePage && <p className="sample-source"><a href={sourcePage} target="_blank" rel="noopener noreferrer">원본 동화 출처 보기</a></p>}
    {failed && <><Notice tone="warning" role="alert">원본을 재생하지 못했어요. 연결을 확인한 뒤 다시 시도해 주세요.</Notice><SecondaryButton onClick={() => { setFailed(false); audio.current?.load() }}><RefreshCcw /> 원본 다시 불러오기</SecondaryButton></>}
  </section>
}
